import {createRequestDataSource} from '@ngneat/elf-requests';
import {select} from '@ngneat/elf';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {invoicesStore} from '@store/invoices/invoices/invoices.store';

export const getInvoicesDataSource = createRequestDataSource({
  store: invoicesStore,
  data$: () => invoicesStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getInvoices',
  dataKey: 'invoices',
});

export const postBillDataSource = createRequestDataSource({
  store: invoicesStore,
  data$: () => invoicesStore.pipe(
    select((state) =>
      Object.values(state.entities)
        .filter((bill) => state.pagination.pages[state.pagination.currentPage].includes(bill.id))
    ),
  ),
  requestKey: 'postBill',
  dataKey: 'bills',
});
